
import React from 'react';
import Layout from './Layout';


export function MyPayers({contractIdIn, walletIn}) {


    //Add feature
    return (
    <Layout wallet={walletIn}>
        <h2>Feature in progress...</h2>
    </Layout>
    );
  }